import { PdfSize, PdfRect, PdfFont, PageGen } from '../../pdf/pdf';

export { PdfSize, PdfRect, PdfFont, PageGen };

export interface Annotation {
  type: 'Note' | 'Warning' | 'Error' | 'Good';
  text: string;
  controlRect?: PdfRect;
}

export interface UIControl {
  type: string;
  content?: string;
  attrs: Record<string, string>;
  children?: UIControl[];
  annotations: Annotation[];
}

export interface SizeConstraint {
  width: number;
  height: number;
}

export interface MeasureParams {
  font: PdfFont;
  page?: PageGen;
}

export interface DrawParams extends MeasureParams {
  page: PageGen;
  annotationHandler?: (ann: Annotation, rect: PdfRect) => void;
}

export interface ArrangedChild {
  child: UIControl;
  rect: PdfRect;
}

export interface IControl {
  readonly type: string;
  measure(control: UIControl, constraint: SizeConstraint, params: MeasureParams): PdfSize;
  draw(control: UIControl, rect: PdfRect, params: DrawParams): void;
}

export interface IContainerControl extends IControl {
  arrange(control: UIControl, rect: PdfRect, params: DrawParams): ArrangedChild[];
}

export function infiniteConstraint(): SizeConstraint {
  return { width: Number.MAX_VALUE, height: Number.MAX_VALUE };
}

export function createConstraint(width: number, height: number): SizeConstraint {
  return { width, height };
}
